import React from 'react'
import _ from 'underscore'
import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'
import CallButton from '../../../buttons/call'
import store from '../../../../../state/store'

class TutorResultCallButton extends React.Component {

  updateJobCandidate(params) {
    store.emit('tutoring_job:tutor_results:update', _.extend(params, {
      tutor_id: this.props.tutor_result.tutor.id,
      tutoring_job_id: this.props.tutoring_job.id
    }))
  }

  onCallOutcomeNoAnswer = () => {
    this.updateJobCandidate({
      call_outcome: 'no_answer'
    })
  }

  onCallOutcomeKeen = () => {
    this.updateJobCandidate({
      call_outcome: 'keen',
      applied: true
    })
  }

  onCallOutcomeNotKeen = () => {
    this.updateJobCandidate({
      call_outcome: 'not_keen',
      declined: true
    })
  }

  render() {
    // unable to copy text from within a dropdown, so phone number && call outcome buttons are split
    const call_outcome = this.props.tutor_result.job_candidate.call_outcome

    return (
      <span className="inline-flex items-center gap-2">
        <CallButton mobile_number={this.props.tutor_result.tutor.mobile_number}/>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" title="Select call outcome">
              Call Outcome <ChevronDown className="size-3.5"/>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem className={cn(call_outcome === 'no_answer' && 'bg-muted')} onSelect={this.onCallOutcomeNoAnswer}>No Answer</DropdownMenuItem>
            <DropdownMenuItem className={cn(call_outcome === 'keen' && 'bg-muted')} onSelect={this.onCallOutcomeKeen}>Tutor Keen</DropdownMenuItem>
            <DropdownMenuItem className={cn(call_outcome === 'not_keen' && 'bg-muted')} onSelect={this.onCallOutcomeNotKeen}>Tutor Not Keen</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </span>
    )
  }
}

export default TutorResultCallButton
